import React, { useCallback, useMemo } from 'react';
import { Select, Input } from '@osui/ui';
import { useDerivedState } from 'huse';
import cs from 'classnames';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
const emptyArray = [undefined, undefined];

function GroupInput({
  onChange,
  options,
  defaultValue = emptyArray,
  selectProps = {
    style: {
      width: 100
    }
  },
  value: valueIn,
  withSuffixIcon,
  placeholder: placeholderIn,
  onSearch,
  ...props
}) {
  const defaultValueIn = valueIn || defaultValue;
  const innerValueIn = useMemo(() => {
    return Array.isArray(defaultValueIn) ? defaultValueIn : [defaultValueIn];
  }, [defaultValueIn]);
  const [value, setValue] = useDerivedState(innerValueIn);
  const onInputChange = useCallback(e => {
    const newValue = [value ? value[0] : undefined, e.target.value];
    setValue(newValue);
    onChange && onChange(newValue);
  }, [value, onChange, setValue]);
  const placeholder = useMemo(() => {
    if (value[0]) {
      var _options$find;

      const label = options === null || options === void 0 ? void 0 : (_options$find = options.find(i => (i === null || i === void 0 ? void 0 : i.value) === value[0])) === null || _options$find === void 0 ? void 0 : _options$find.label;
      return `输入${label}关键字搜索`;
    }

    return '请输入';
  }, [options, value]);
  const onSelectChange = useCallback(v => {
    const newValue = [v, value ? value[1] : undefined];
    setValue(newValue);
    onChange && onChange(newValue);
  }, [value, onChange, setValue]);
  const onInputSearch = useCallback(v => {
    const newValue = [value ? value[0] : undefined, v];
    setValue(newValue);
    onSearch && onSearch(newValue);
  }, [value, onSearch, setValue]);

  if (withSuffixIcon) {
    return /*#__PURE__*/_jsx(Input.Search, {
      withSuffixIcon: true,
      addonBefore: /*#__PURE__*/_jsx(Select, {
        options: options,
        onChange: onSelectChange,
        value: value[0],
        ...selectProps
      }),
      onChange: onInputChange,
      value: value[1],
      placeholder: placeholderIn || placeholder,
      onSearch: onInputSearch,
      ...props,
      className: cs('icloud-ui-group-search', 'icloud-ui-group-input', props.className)
    });
  }

  return /*#__PURE__*/_jsx(Input, {
    addonBefore: /*#__PURE__*/_jsx(Select, {
      options: options,
      onChange: onSelectChange,
      value: value[0],
      ...selectProps
    }),
    value: value[1],
    placeholder: placeholderIn || placeholder,
    onChange: onInputChange,
    ...props,
    className: cs('icloud-ui-group-input', props.className)
  });
}

GroupInput.displayName = "GroupInput";

function GroupSearch(props) {
  return /*#__PURE__*/_jsx(GroupInput, {
    withSuffixIcon: true,
    allowClear: true,
    ...props
  });
}

GroupSearch.displayName = "GroupSearch";
GroupInput.GroupSearch = GroupSearch;
export default GroupInput;
//# sourceMappingURL=es/index.js.map